import {createStructuredSelector} from 'reselect';
import {
  getErrorFreeSelectedProduct,
  getSelectedProductColor,
  getSelectedProductColorSizes
} from '~/selectors/ProductSelectors';
import {bindActionCreators} from 'redux';
import {loadStyles} from '~/actions/CatalogActions';
import {
  productSummary,
  productSummaryCarousel
} from '~/actions/AnalyticsActions';

export function select() {
  const selector = createStructuredSelector({
    product: getErrorFreeSelectedProduct,
    selectedColor: getSelectedProductColor,
    colorSizes: getSelectedProductColorSizes
  });
  return (state, props) => selector(state, props);
}

export function actions(dispatch) {
  return {
    loadStyles: bindActionCreators(loadStyles, dispatch),
    meta: bindActionCreators({productSummary, productSummaryCarousel}, dispatch)
  };
}
